function ClockIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 19 18"
      fill="#A8ADB2"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M9.75 0a9 9 0 100 18 9 9 0 000-18zm0 3.103a.62.62 0 01.62.621v5.024l3.114 3.103a.627.627 0 010 .883.626.626 0 01-.883 0L9.313 9.437A.615.615 0 019.13 9V3.724a.62.62 0 01.62-.62h.001z" />
    </svg>
  )
}

export default ClockIcon
